"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LightWeightChart = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lightweightCharts = require("lightweight-charts");
var _reactRedux = require("react-redux");
var _get = _interopRequireDefault(require("lodash/get"));
var _config = _interopRequireDefault(require("../../config"));
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
var _IntervalButtons = require("./IntervalButtons");
var _dateHelper = require("../../helpers/dateHelper");
var _decimalPlacesHelper = require("../../helpers/decimalPlaces/decimalPlacesHelper");
var _numberFormatter = require("../../helpers/numberFormatter");
var _withCssVars = require("../Theme/withCssVars");
var _selectors = require("../../redux/futures/selectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LightWeightCharts = _config["default"].LightWeightCharts,
  global = _config["default"].global;
var locale = global.locale;
function makeOHLC(frame) {
  // Make sure the frame is valid and has enough data points
  if (!frame || !Array.isArray(frame) || frame.length < 5) {
    return null;
  }
  return {
    time: frame[0] / 1000,
    high: frame[1],
    low: frame[2],
    open: frame[3],
    close: frame[4]
  };
}
function makeValueFrame(frame) {
  var targetIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
  // Make sure the frame is valid and has enough data points
  if (!frame || !Array.isArray(frame) || frame.length <= targetIndex) {
    return null;
  }
  return {
    time: frame[0] / 1000,
    value: frame[targetIndex]
  };
}
function getFrameFormatter(chartType) {
  if (chartType === 'candlestick') return makeOHLC;
  return function (frame) {
    return makeValueFrame(frame);
  };
}
function getChartConstructor(chartType) {
  if (chartType === 'candlestick') return 'addCandlestickSeries';
  return 'addAreaSeries';
}
var LightWeightChartComponent = /*#__PURE__*/function (_React$Component) {
  function LightWeightChartComponent() {
    var _this;
    _classCallCheck(this, LightWeightChartComponent);
    _this = _callSuper(this, LightWeightChartComponent);
    _defineProperty(_this, "resizeHandler", function () {
      if (!_this.chart || !_this.chartContainerRef.current) {
        return;
      }
      var width = _this.chartContainerRef.current.offsetWidth;
      var height = _this.chartContainerRef.current.offsetHeight - (_this.props.hideIntervalButtons ? 0 : 35);
      if (height <= 0 || width <= 0) {
        return;
      }
      _this.chart.applyOptions({
        width: width,
        height: height
      });
    });
    _this.chart = null;
    _this.chartContainerRef = /*#__PURE__*/(0, _react.createRef)();
    _this.wrapperRef = /*#__PURE__*/(0, _react.createRef)();
    _this.priceSeries = null;
    _this.volumeSeries = null;
    return _this;
  }
  _inherits(LightWeightChartComponent, _React$Component);
  return _createClass(LightWeightChartComponent, [{
    key: "initializeChart",
    value: function initializeChart() {
      var _this$wrapperRef$curr, _this$wrapperRef$curr2;
      var _this$props = this.props,
        selectedInstrument = _this$props.selectedInstrument,
        getCssVar = _this$props.getCssVar;
      var decimals = (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.PriceIncrement);

      // Only create chart if container has positive size
      var rawHeight = ((_this$wrapperRef$curr = this.wrapperRef.current) === null || _this$wrapperRef$curr === void 0 ? void 0 : _this$wrapperRef$curr.offsetHeight) || 0;
      var rawWidth = ((_this$wrapperRef$curr2 = this.wrapperRef.current) === null || _this$wrapperRef$curr2 === void 0 ? void 0 : _this$wrapperRef$curr2.offsetWidth) || 0;
      var height = rawHeight - (this.props.hideIntervalButtons ? 0 : 35);
      var width = rawWidth;
      // If not ready, try again on next update
      if (height <= 0 || width <= 0) {
        return;
      }
      this.chart = (0, _lightweightCharts.createChart)(this.chartContainerRef.current, {
        height: height,
        width: width,
        layout: {
          fontFamily: getCssVar('font__typeface'),
          textColor: getCssVar('font__color-secondary'),
          background: {
            type: 'solid',
            color: getCssVar('secondary__bg-color')
          }
        },
        grid: {
          vertLines: {
            color: getCssVar('tv-chart__grid-vertical-color')
          },
          horzLines: {
            color: getCssVar('tv-chart__grid-horizontal-color')
          }
        },
        crosshair: {
          mode: 0
        },
        rightPriceScale: {
          borderColor: getCssVar('tv-chart__scale-font-color')
        },
        timeScale: {
          borderColor: getCssVar('tv-chart__scale-font-color'),
          rightBarStaysOnScroll: true,
          timeVisible: true
        },
        localization: {
          locale: locale,
          dateFormat: LightWeightCharts.dateFormat,
          timeFormatter: function timeFormatter(businessDayOrTimestamp) {
            if ((0, _lightweightCharts.isBusinessDay)(businessDayOrTimestamp)) {
              return '';
            }
            return (0, _dateHelper.formatTime)(businessDayOrTimestamp * 1000);
          },
          priceFormatter: function priceFormatter(price) {
            return (0, _numberFormatter.formatNumberToLocale)(price, decimals);
          }
        }
      });
      window.addEventListener('resize', this.resizeHandler);
      var func = getChartConstructor(this.props.chartType || _config["default"].LightWeightCharts.chartType);
      var chartConfig = this.getChartConfig();
      this.priceSeries = this.chart[func](chartConfig);
      if (!this.props.hideVolume && _config["default"].LightWeightCharts.showVolume) {
        this.volumeSeries = this.chart.addHistogramSeries({
          base: 0,
          color: 'rgba(238, 238, 238, 0.2)',
          priceFormat: {
            type: 'volume'
          },
          priceScaleId: ''
        });
        this.volumeSeries.priceScale('left').applyOptions({
          scaleMargins: {
            top: 0.8,
            bottom: 0
          }
        });
      }
      if (this.props.priceData.length) {
        this.updateChartData();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.selectedInstrument) {
        this.initializeChart();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.selectedInstrument && !this.chart) {
        this.initializeChart();
      } else if (prevProps.selectedInstrument !== this.props.selectedInstrument && this.props.selectedInstrument && this.chart) {
        var _this$priceSeries, _this$volumeSeries;
        var decimalPlaces = (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(this.props.selectedInstrument.PriceIncrement);
        this.chart.applyOptions({
          localization: {
            priceFormatter: function priceFormatter(price) {
              return (0, _numberFormatter.formatNumberToLocale)(price, decimalPlaces);
            }
          }
        });
        (_this$priceSeries = this.priceSeries) === null || _this$priceSeries === void 0 || _this$priceSeries.setData([]);
        (_this$volumeSeries = this.volumeSeries) === null || _this$volumeSeries === void 0 || _this$volumeSeries.setData([]);
      }
      if (prevProps.priceData !== this.props.priceData) {
        this.updateChartData();
      }
      if (prevProps.theme !== this.props.theme && this.chart) {
        this.chart.applyOptions({
          layout: {
            textColor: this.props.getCssVar('font__color-secondary'),
            background: {
              type: 'solid',
              color: this.props.getCssVar('secondary__bg-color')
            }
          },
          grid: {
            vertLines: {
              color: this.props.getCssVar('tv-chart__grid-vertical-color')
            },
            horzLines: {
              color: this.props.getCssVar('tv-chart__grid-horizontal-color')
            }
          },
          rightPriceScale: {
            borderColor: this.props.getCssVar('tv-chart__scale-font-color')
          },
          timeScale: {
            borderColor: this.props.getCssVar('tv-chart__scale-font-color')
          }
        });
        var chartConfig = this.getChartConfig();
        this.priceSeries.applyOptions(chartConfig);
      }
    }
  }, {
    key: "getChartConfig",
    value: function getChartConfig() {
      var _this$props2 = this.props,
        getCssVar = _this$props2.getCssVar,
        _this$props2$chartTyp = _this$props2.chartType,
        chartType = _this$props2$chartTyp === void 0 ? _config["default"].LightWeightCharts.chartType : _this$props2$chartTyp;
      var bullish = getCssVar('chart__bullish-color');
      var bearish = getCssVar('chart__bearish-color');
      if (chartType === 'candlestick') {
        return {
          upColor: bullish,
          downColor: bearish,
          wickUpColor: bullish,
          wickDownColor: bearish,
          borderVisible: false
        };
      }
      return {
        bottomColor: getCssVar('default-price-line-color'),
        topColor: bullish,
        color: bullish,
        lineColor: bullish,
        priceLineColor: bullish,
        lineStyle: 0,
        lineWidth: 2
      };
    }
  }, {
    key: "updateChartData",
    value: function updateChartData() {
      var _this$volumeSeries2;
      if (!this.priceSeries) {
        return;
      }
      var chartType = this.props.chartType || _config["default"].LightWeightCharts.chartType;
      var priceFormatter = getFrameFormatter(chartType);
      var priceData = [];
      var volData = [];
      this.props.priceData.forEach(function (el) {
        var formattedPrice = priceFormatter(el);
        var formattedVol = makeValueFrame(el, 5);
        if (formattedPrice) {
          priceData.push(formattedPrice);
        }
        if (formattedVol) {
          volData.push(formattedVol);
        }
      });
      // FIXME: setDate() is not optimal from the performance perspective,
      // the .update() method is recommended to update only specific entries.
      // But it can updates only the last entry, and throws the error when I try
      // to update the others. This is the case when you change the period, for example.
      // And it's hard to track when this happens, because first the
      // `selectedInterval` changes, and the `priceData` changes on the next update.
      this.priceSeries.setData(priceData);
      (_this$volumeSeries2 = this.volumeSeries) === null || _this$volumeSeries2 === void 0 || _this$volumeSeries2.setData(volData);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$chart;
      window.removeEventListener('resize', this.resizeHandler);
      (_this$chart = this.chart) === null || _this$chart === void 0 || _this$chart.remove();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "lightweight-chart",
        ref: this.wrapperRef
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "lightweight-chart-container",
        className: "lightweight-chart",
        ref: this.chartContainerRef
      }), !this.props.hideIntervalButtons && /*#__PURE__*/_react["default"].createElement(_IntervalButtons.IntervalButtons, this.props));
    }
  }]);
}(_react["default"].Component);
_defineProperty(LightWeightChartComponent, "propTypes", {
  selectedInstrument: _propTypes["default"].object.isRequired,
  selectedInstrumentId: _propTypes["default"].string.isRequired,
  priceData: _propTypes["default"].array.isRequired,
  chartType: _propTypes["default"].string,
  hideVolume: _propTypes["default"].bool,
  hideIntervalButtons: _propTypes["default"].bool,
  getCssVar: _propTypes["default"].func.isRequired,
  theme: _propTypes["default"].string.isRequired
});
var LightWeightChart = exports.LightWeightChart = (0, _withCssVars.withCssVars)(LightWeightChartComponent);
var mapStateToProps = function mapStateToProps(state) {
  var isFuturesActive = (0, _selectors.isFuturesActiveSelector)(state);
  var selectedInstrument = isFuturesActive ? (0, _selectors.futuresSelectedInstrumentSelector)(state) : (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  return {
    selectedInstrument: selectedInstrument,
    selectedInstrumentId: selectedInstrument === null || selectedInstrument === void 0 ? void 0 : selectedInstrument.InstrumentId,
    priceData: isFuturesActive ? (0, _selectors.getFuturesTickersList)(state) : (0, _get["default"])(state, 'tickers.tickers', []),
    selectedInterval: state.tickers.interval,
    isFuturesActive: isFuturesActive
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(LightWeightChart);